<template>

  <TheNavbar />

  <div v-if="userProfile" class="mt-5 mb-5">

    <div class="row justify-content-center mb-3">
      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">

        <ApiKeyCreateForm />
        <ApiKeyList :loading="loading" />
        <ApiKeyDocs />

      </div>
    </div>

  </div>
</template>

<script>
import TheNavbar from '@/components/TheNavbar'
import ApiKeyCreateForm from '@/components/ApiKeyCreateForm'
import ApiKeyList from '@/components/ApiKeyList'
import ApiKeyDocs from '@/components/ApiKeyDocs'

export default {
  components: {
    TheNavbar,
    ApiKeyCreateForm,
    ApiKeyList,
    ApiKeyDocs
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    userProfile () {
      return this.$store.getters.getUserProfile
    }
  },
  async created () {
    if (!this.$store.getters.getApiKeys) {
      this.loading = true
      await this.$store.dispatch('getApiKeys')
      this.loading = false
    }
  },
  beforeMount () {
    // Redirect to Login when the user is not logged in
    if (!this.$store.getters.isUserLoggedIn) this.$router.push({ name: 'Login' })
  }
}
</script>
